<template>
  <m-calendar ref="calendar" :options="options" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MCalendar from "./../MCalendar";

import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";

const plugins = [resourceTimelinePlugin, interactionPlugin];

export default defineComponent({
  components: { MCalendar },

  props: {
    initialView: {
      type: String,
      default: "resourceTimeline",
    },

    headerToolbar: {
      type: Object,
      default() {
        return { start: "", center: "", end: "" };
      },
    },
    height: {
      type: String,
      default() {
        return "100%";
      },
    },
    slotDuration: {
      type: [String, Object],
      default() {
        return { minutes: 30 };
      },
    },

    dropable: Boolean,
    eventResourceEditable: Boolean,

    dateClick: Function,
    eventClick: Function,
    events: Array,
    eventSources: Array,

    resources: Array,

    initialDate: [Object, Number, String],
  },

  computed: {
    options() {
      return Object.assign(
        {
          plugins,
        },
        this.$props,
      );
    },
  },
});
</script>

<style></style>
